/**
 * @generated SignedSource<<2285d0d1f88cc563f1f2b92458f234a4>>
 * @relayHash bd6dbc5adaecf4efb9df56ffa90d58d8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID fe6e73323e192b86de137616515efbe5a7e7b42f6550cdb18ddd026aa7f938d5

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type handoffConfig_csmAiHubQuery$variables = {
  helpCenterAri: string;
};
export type handoffConfig_csmAiHubQuery$data = {
  readonly csmAi_getAiHubByHelpCenterAri: {
    readonly __typename: "CsmAiHub";
    readonly " $fragmentSpreads": FragmentRefs<"configuration_AtlassianCsmHandoffConfig">;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
};
export type handoffConfig_csmAiHubQuery = {
  response: handoffConfig_csmAiHubQuery$data;
  variables: handoffConfig_csmAiHubQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "helpCenterAri"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "helpCenterAri",
    "variableName": "helpCenterAri"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v3 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "handoffConfig_csmAiHubQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "args": (v1/*: any*/),
          "kind": "LinkedField",
          "name": "csmAi_getAiHubByHelpCenterAri",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "configuration_AtlassianCsmHandoffConfig"
                }
              ],
              "type": "CsmAiHub"
            }
          ]
        },
        "action": "THROW",
        "path": "csmAi_getAiHubByHelpCenterAri"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "handoffConfig_csmAiHubQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "csmAi_getAiHubByHelpCenterAri",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "LinkedField",
                "name": "handoffConfigs",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "type"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "enabled"
                      },
                      (v3/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "connectorConfiguration",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "message"
                              }
                            ],
                            "type": "CsmAiMessageHandoff"
                          }
                        ]
                      }
                    ],
                    "type": "CsmAiHandoffConfig"
                  }
                ]
              },
              (v3/*: any*/)
            ],
            "type": "CsmAiHub"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "fe6e73323e192b86de137616515efbe5a7e7b42f6550cdb18ddd026aa7f938d5",
    "metadata": {},
    "name": "handoffConfig_csmAiHubQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "841642ca04c73dc56596f8461c555698";

export default node;
